<template>
    <div>
        <div v-if="!isEmpty">
            <button v-if="!isEmpty" @mouseup="$emit('input', null)">{{ __('Remover') }}</button>
            <a :href="value" target="_blank" reflinks="false">{{ __('Download') }}</a>
        </div>

        <label>
            <input class="hidden" type="file" @change="upload($event)" />

            <div class="truncate">
                <span v-if="uploadProgress === 0" class="truncate">
                    <div v-if="isImage">
                        <img v-if="isImage" :src="value" class="w-12 h-auto max-h-12" />
                    </div>

                    <div v-else-if="isEmpty">
                        <div class="cursor-pointer flex items-center space-x-2">
                            <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path
                                    fill-rule="evenodd"
                                    d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                            <span>{{ __('Upload') }}</span>
                        </div>
                    </div>

                    <div v-else class="truncate">
                        <div class="border rounded p-1 text-sm">
                            {{ value }}
                        </div>
                    </div>
                </span>
                <span v-else>{{ __('Upload: :pct%', { pct: uploadProgress }) }}</span>
            </div>
        </label>
    </div>
</template>

<script>
import { extrairJson } from '@App/Changeset'
import axios from 'axios'
import { meta } from '@App/Meta'

export default {
    props: ['value', 'name', 'arquivavelType', 'arquivavelId'],
    data() {
        return {
            uploadProgress: 0,
        }
    },
    computed: {
        isImage() {
            if (!this.value) return false
            return this.value.indexOf('.png') !== -1 || this.value.indexOf('.jpeg') !== -1
        },
        isEmpty() {
            return !this.value
        },
    },
    methods: {
        upload(e) {
            if (!e.target) return

            let data = new FormData()
            data.append('files[]', e.target.files[0])
            this.uploadProgress = 0

            const arquivavelType = this.arquivavelType || meta('arquivavel-type')
            const arquivavelId = this.arquivavelId || meta('arquivavel-id')

            data.append('arquivável_type', arquivavelType)
            data.append('arquivável_id', arquivavelId)

            const uploadUrl = meta('user-id') ? '/core/arquivos' : '/api/core/files'

            axios({
                method: 'post',
                url: uploadUrl,
                data: data,
                onUploadProgress: (ev) => {
                    this.uploadProgress = Math.round((ev.loaded * 100) / ev.total)
                },
            })
                .then((res) => {
                    this.uploadProgress = 0
                    let arquivos = extrairJson(res.data, 'arquivos')

                    let url = arquivos[0].url
                    this.$emit('input', url)
                })
                .catch((err) => {
                    console.log(err)
                    window.alert(__('Não foi possível realizar upload. Por favor, tente novamente mais tarde.'))
                })
        },
    },
}
</script>
